import { Loader } from '@gurupay/gp-ui-library';
import clsx from 'clsx';
import { Controller } from 'react-hook-form';

import Selector from '../select/select';

interface SimpleInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	options: { value: string; label: string }[];
	label?: string;
	isMandatory?: boolean;
	leftText?: string;
	inputRegister: any;
	selectorRegister: any;
	control: any;
	isError?: boolean;
	disableTyping?: boolean;
	onSelectorChange?: (value: { value: string; label: string }) => void;
	isLoading?: boolean;
	className?: string;
	style?: React.CSSProperties;
	onInput?: () => void;
}

const InputDropdown = (props: SimpleInputProps) => {
	const inputId = props.label?.toLowerCase().replace(/\s+/g, '-');

	const filterDecimalInput = (event: React.FormEvent<HTMLInputElement>) => {
		let value = event.currentTarget.value;

		value = value.replace(',', '.');

		value = value.replace(/[^0-9.]/g, '').replace(/^([^.]*\.[^.]*)\..*$/, '$1');

		event.currentTarget.value = value;
	};

	return (
		<div className={props.className}>
			{props.label && (
				<label className="mb-space-8 text-base-bold flex gap-space-4" htmlFor={inputId}>
					{props.label}
					{props.isMandatory && <span> *</span>}
				</label>
			)}
			<div
				className={clsx(
					'relative w-full max-w-[500px] flex',
					'has-[input:focus-visible]:outline-2 has-[input:focus-visible]:outline-brand-secondary-700 has-[input:focus-visible]:outline-offset-2 rounded-sm',
				)}
			>
				<div
					className={clsx(
						'flex items-center gap-space-8 px-space-16 h-12 rounded-lg border border-solid text-base-medium w-full text-neutral-950',
						props.isError
							? 'border-status-error-500'
							: 'border-neutral-200 focus-within:border-neutral-950',
						props.disableTyping && 'bg-neutral-50 border-none cursor-not-allowed',
						'peer',
					)}
					style={props.style}
				>
					<Controller
						control={props.control}
						name={props.selectorRegister.name}
						render={({ ...field }) => {
							return (
								<Selector
									{...field}
									fullWidth={props.fullWidth}
									onChange={props.onSelectorChange}
									options={props.options || []}
								/>
							);
						}}
					/>
					<input
						className={clsx(
							'w-full bg-transparent outline-none h-full text-base-medium placeholder-transparent text-right',
							props.disableTyping && 'pointer-events-none text-neutral-950',
						)}
						id={inputId}
						inputMode={props.inputMode}
						onInput={(e) => {
							if (props.inputMode === 'decimal') {
								filterDecimalInput(e);
							}
							props.onInput?.();
						}}
						onKeyDown={props.disableTyping ? (e) => e.preventDefault() : undefined}
						onPaste={props.disableTyping ? (e) => e.preventDefault() : undefined}
						pattern={props.pattern}
						placeholder={props.placeholder}
						readOnly={props.disableTyping}
						type={props.type}
						{...props.inputRegister}
					/>
				</div>
				{props.isLoading && (
					<div className="mt-space-8 ml-space-4">
						<Loader />
					</div>
				)}
			</div>
		</div>
	);
};

export default InputDropdown;
